import React, { forwardRef } from "react";
import { Container, HelperText, Label } from "../Input/Input.styles";
import { BaseTextarea } from "./Textarea.styles";

export interface TextareaProps extends React.HTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  colorLabel?: string;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  name?: string;
  rows?: number;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  value?: string | number | readonly string[];
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      placeholder,
      helperText,
      error,
      name,
      colorLabel,
      rows = 4,
      onChange,
      value,
      ...props
    },
    ref
  ) => {
    const textareaId = name ? `textarea-${name}` : undefined;

    return (
      <Container>
        {!!label && (
          <Label htmlFor={textareaId} color={colorLabel}>
            {label}
          </Label>
        )}

        <BaseTextarea
          ref={ref}
          id={name ? `textarea-${name}` : undefined}
          name={name}
          placeholder={placeholder}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={error && name ? `${name}-error` : undefined}
          rows={rows}
          onChange={onChange}
          value={value}
          borderColor={!error ? undefined : "#F3322B"}
          {...props}
        />

        {!!helperText && (
          <HelperText style={{ color: !error ? "#64748B" : "#F3322B" }} id={`${textareaId}-error`}>
            {helperText}
          </HelperText>
        )}
      </Container>
    );
  }
);